import React from "react";
import { Form, Icon, Input, Button, Row, Col, Select } from "antd";

const Option = Select.Option;
const ButtonGroup = Button.Group;

export const FormComponent = props => {
  if (props.type && (props.destinationValue || props.newForm) && !props.deleted)
    return (
      <Row gutter={6} style={{ margin: "5px 0" }}>
        <Col span={10}>
          <Input
            size="small"
            prefix={<Icon type="logout" style={{ color: "rgba(0,0,0,.25)" }} />}
            placeholder="source"
            disabled={props.disabled || props.deleted}
            onChange={props.onSourceChange}
            value={props.sourceValue}
          />
        </Col>

        <Col span={10}>
          {props.type === "ArtworkType" && (
            <Select
              defaultValue={props.destinationValue}
              size="small"
              disabled={props.disabled || props.deleted}
              onChange={props.onDestinationSelect}
              style={{ width: "100%" }}
            >
              <Option value="Rich Media">Rich Media</Option>
              <Option value="Media">Media</Option>
            </Select>
          )}
          {(props.type === "ProofLink" || props.type === "XandrNative" || props.type === "XandrWallpaper") && (
            <Input
              size="small"
              prefix={
                <Icon type="login" style={{ color: "rgba(0,0,0,.25)" }} />
              }
              type="text"
              disabled={props.disabled || props.deleted}
              placeholder="destination"
              value={props.destinationValue}
              onChange={props.onDestinationChange}
            />
          )}
        </Col>
        <Col span={4} className="text-right">
          <ButtonGroup size="small">
            {!props.newForm && (
              <Button
                disabled={props.disabled || props.deleted}
                loading={props.deleting}
                type="danger"
                icon="delete"
                onClick={props.onDelete}
              />
            )}
              <Button
                disabled={props.disabled || props.deleted}
                loading={props.processing}
                type="link"
                icon="check"
                onClick={props.newForm ? props.onSave : props.onUpdate}
              />
          </ButtonGroup>
        </Col>
      </Row>
    );
  return null;
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/Form/FormComponent.js